// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".model-widget{border:1px dashed transparent;position:relative}.model-widget.disabled{border:none!important}.model-widget.disabled .widget-tag{display:none!important}.model-widget .widget-tag{background-color:rgba(245,63,63,.7);display:none}.model-widget:hover{border:1px dashed #f16b67}.model-widget:hover .widget-tag{display:block}.model-widget.active{border:1px dashed #f16b67}.model-widget.active .widget-tag{display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
